export default breakpoints => {
  if (
    !breakpoints ||
    breakpoints === '' ||
    !breakpoints.includes(':')
  ) {
    return {};
  }

  const arr = breakpoints
    .split(',')
    .map(bp => bp.split(':'))
    .map(bp => ({
      width: bp[0] ? parseInt(bp[0], 10) : null,
      columns: bp[1] ? parseInt(bp[1], 10) : null,
    }));

  const currentBreakpoint = arr
    .filter(item => item.width <= window.innerWidth)
    .pop();

  if (!currentBreakpoint) {
    return {};
  }

  return currentBreakpoint;
};
